import {FOLLOW_UP_SERVICE} from "@/store/constants";

const REQUIREMENTS = "/requirements"
const FOLLOW_UPS = "/follow-ups"

export const actions = {
    feedback ({ commit, dispatch }, notification) {
        // Called by websocket/notification when backend sends a feedback notification.
        const contract = notification.attributes.target.substring('contract:'.length)
        const route = `/${notification.tenant}/contract/show/${contract}`
        dispatch('message', { subject: notification.subject, body: notification.body, attributes: { route } }, { root: true})
        commit('feedback', notification)
        return Promise.resolve(notification)
    },
    getRequirements({dispatch}, {target}) {
        return new Promise(function (resolve, reject) {
            dispatch('API', FOLLOW_UP_SERVICE, {root: true})
                .then(api => api.get(REQUIREMENTS + '?target=' + encodeURIComponent(target)))
                .then(response => resolve(response.data))
                .catch(err => reject(err))
        })
    },
    saveRequirement({commit, dispatch}, data) {
        return new Promise(function (resolve, reject) {
            dispatch('API', FOLLOW_UP_SERVICE, {root: true})
                .then(api => {
                    if (data.id) {
                        return api.put(REQUIREMENTS + '/' + encodeURIComponent(data.id), data)
                    }
                    return api.post(REQUIREMENTS, data)
                })
                .then(response => resolve(response.data))
                .catch(err => reject(err))
        })
    },
    deleteRequirement({commit, dispatch}, {id}) {
        return new Promise(function (resolve, reject) {
            dispatch('API', FOLLOW_UP_SERVICE, {root: true})
                .then(api => api.delete(REQUIREMENTS + '/' + encodeURIComponent(id)))
                .then(response => resolve(response.data))
                .catch(err => reject(err))
        })
    },

    getFollowUps({dispatch}, params) {
        return new Promise(function (resolve, reject) {
            let query
            if (params.requirement) {
                query = '?requirement=' + encodeURIComponent(params.requirement)
            } else if(params.target) {
                query = '?target=' + encodeURIComponent(params.target)
            } else {
                return Promise.resolve([])
            }
            dispatch('API', FOLLOW_UP_SERVICE, {root: true})
                .then(api => api.get(FOLLOW_UPS + query))
                .then(response => resolve(response.data))
                .catch(err => reject(err))
        })
    },
    saveFollowUp({commit, dispatch}, data) {
        return new Promise(function (resolve, reject) {
            dispatch('API', FOLLOW_UP_SERVICE, {root: true})
                .then(api => {
                    if (data.id) {
                        return api.put(FOLLOW_UPS + '/' + encodeURIComponent(data.id), data)
                    }
                    return api.post(FOLLOW_UPS, data)
                })
                .then(response => resolve(response.data))
                .catch(err => reject(err))
        })
    },
}
